import type { RootState } from 'store';

export const selectPendingEventEntry = (state: RootState) => state.eventEntry.pending;
export const selectEnteringEventId = (state: RootState) => state.eventEntry.enteringEventId;
